// removed by extract-text-webpack-plugin
module.exports = {"box":"_1CfXwsqDiD-RqImw7R49J3","overlay":"_1hWQdfNFjIrHIiCVUq9n0y","card":"_2AUkJwwzuoXkwDsm-cI5uf","active":"_39NS7vT7RzF_mPFvQdfddc","timeBox":"_1RngmhPVdojNtMP3fRIWlc","center":"_3i-BbplOijZF06CoLZfuDF","time":"_2D3__x4RvBEq4jWPes5Xgg","promotion":"_2Iwx0wyBgpVIS5G1yN9qFr","slot":"_162TFmINpbrK3Wh08DoeY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/BookingTimeCard.scss
// module id = 1102
// module chunks = 0